function getConfigCompoment () { return 'ExtMapConfigCompoment' }
function getStandardAttributes () { return null }

export default {
  hasSync: false,
  hasExecutions: true,
  hasItemSync: false,
  canManageAttributes: true,
  getConfigCompoment,
  getStandardAttributes
}
